/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-external-order.reducer';

export const PharmacyExternalOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyExternalOrderEntity = useAppSelector(state => state.pharmacyExternalOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyExternalOrderDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.detail.title">PharmacyExternalOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.status">Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.status}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.timestampEntry}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.modifiedById}</dd>
          <dt>
            <span id="fulfilledById">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.fulfilledById">Fulfilled By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.fulfilledById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.modifiedByType}</dd>
          <dt>
            <span id="fulfilledByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.fulfilledByType">Fulfilled By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.fulfilledByType}</dd>
          <dt>
            <span id="orderDirection">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.orderDirection">Order Direction</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.orderDirection}</dd>
          <dt>
            <span id="supplierId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.supplierId">Supplier Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.supplierId}</dd>
          <dt>
            <span id="supplierIdType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.supplierIdType">Supplier Id Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.supplierIdType}</dd>
          <dt>
            <span id="consumerId">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.consumerId">Consumer Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.consumerId}</dd>
          <dt>
            <span id="consumerType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.consumerType">Consumer Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.consumerType}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.createdById">Created By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.createdById}</dd>
          <dt>
            <span id="createdByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrder.createdByType">Created By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyExternalOrderEntity.createdByType}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-external-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-external-order/${pharmacyExternalOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyExternalOrderDetail;
